<template>
    <div class="flexible-packaging-card user-select-none" :class="{'active' : active}">
        <slot>
            <div class="d-flex justify-content-center position-relative pb-2">
                <img class="img-fluid" :src="icon">
            </div>
            <div class="text-muted text-center fs-4 fw-500">{{ title }}</div>
        </slot>
    </div>
</template>

<script>
export default {
    props: ['title', 'icon', 'active'],
}
</script>

<style lang="scss" scoped>
.flexible-packaging-card {
    min-height: 216px;
    max-width: 185px;
    padding: 16px;
}

@media (max-width: 615px) {
    .flexible-packaging-card {
        min-height: 0;
        max-width: 45%;
        flex-grow: 1;
    }
}
</style>

